export default "__VITE_PUBLIC_ASSET__c0d39a09__"